/* eslint-disable */
import http from "../../api/http"; /** file configured to make requests to the server with fetch */
import auth from "../../auth";
var _ = require("lodash");
const actions = {
     FetchSubgroups({commit},payload) {
        return http.get("subgroups_select", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                var all = response.DATA
                all.unshift({ID:"-1",name:'ALL'})
                commit('SetSubgroup',all);
            } 
            return response;
        });
    },
    FetchSubgroupsUser({commit},payload) {
        return http.get("subgroups_select_user", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                var all = response.DATA
                all.unshift({ID:"-1",name:'ALL'})
                commit('SetSubgroupUser',all);
            } 
            return response;
        });
    }
};
export default actions;